import { PortableText, PortableTextBlock, PortableTextProps, type PortableTextReactComponents } from '@portabletext/react';
import { Body, Bold } from '@rikstv/shared-components';
import type { FC } from 'react';
import Banner from '../banner/Banner';

type Serializer = Partial<PortableTextReactComponents>;
const defaultComponents: Serializer = {
  marks: {
    link: (props) => (
      <a target="_blank" href={props.value.href} rel="noopener noreferrer">
        {props.children}
      </a>
    ),
    strong: (props) => <Bold>{props.children}</Bold>,
  },
  types: {
    banner: (props) => <Banner {...props} />,
  },
};

// TODO: add more RDS components here, check implementation in StrimWebApp for hints
const rdsComponents: Serializer = {
  ...defaultComponents,
  block: (props) => <Body>{props.children}</Body>,
  marks: {
    ...defaultComponents.marks,
    strong: (props) => <Bold>{props.children}</Bold>,
  },
} satisfies Serializer;

type Props = FC<
  Omit<PortableTextProps, 'value'> & {
    blocks?: PortableTextBlock | PortableTextBlock[];
    serializers?: Serializer;
    className?: string;
    renderContainerOnSingleChild?: boolean;
    useRdsComponents?: boolean;
  }
>;

export const DefaultBlockContent: Props = (props) => {
  const { blocks, serializers, useRdsComponents, ...other } = props;

  if (!blocks) return null;
  const components = useRdsComponents ? { ...rdsComponents, ...serializers } : { ...defaultComponents, ...serializers };

  return <PortableText components={components} value={blocks} {...other} />;
};
